import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const LoginEmbed = () => {
  const openLoginPage = () => {
    window.open("https://schoolifix.com/sign2", "_blank");
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Navbar />

      <div className="flex flex-col items-center justify-center flex-1 px-4 py-12">
        {/* Main Login Card */}
        <div className="w-full max-w-md p-8 bg-white border border-gray-100 shadow-xl rounded-2xl">
          {/* Header Section */}
          <div className="mb-8 text-center">
            <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r from-blue-500 to-indigo-600">
              <svg 
                className="w-8 h-8 text-white" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" 
                />
              </svg>
            </div>
            <h2 className="mb-2 text-3xl font-bold text-gray-800">
              School Portal
            </h2>
            <p className="text-gray-600">
              Access your educational dashboard and resources
            </p>
          </div>

          {/* Login Button */}
          <button
            onClick={openLoginPage}
            className="w-full px-6 py-4 font-semibold text-white transition-all duration-200 ease-in-out transform shadow-lg bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl hover:from-blue-700 hover:to-indigo-700 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-300 focus:ring-opacity-50"
          >
            <div className="flex items-center justify-center space-x-2">
              <svg 
                className="w-5 h-5" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" 
                />
              </svg>
              <span>Login to Portal</span>
            </div>
          </button>

          {/* Additional Info */}
          <div className="pt-6 mt-6 border-t border-gray-100">
            <div className="text-sm text-center text-gray-500">
              <p className="mb-2">Need help accessing your account?</p>
              <div className="flex justify-center space-x-4">
                <a href="#" className="text-blue-600 transition-colors hover:text-blue-700">
                  Forgot Password
                </a>
                <span className="text-gray-300">|</span>
                <a href="#" className="text-blue-600 transition-colors hover:text-blue-700">
                  Contact Support
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="grid w-full max-w-4xl grid-cols-1 gap-6 px-4 mt-12 md:grid-cols-3">
          <div className="p-6 text-center border bg-white/70 backdrop-blur-sm rounded-xl border-white/20">
            <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-green-100 rounded-full">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="mb-2 font-semibold text-gray-800">Secure Access</h3>
            <p className="text-sm text-gray-600">Protected login with advanced security measures</p>
          </div>

          <div className="p-6 text-center border bg-white/70 backdrop-blur-sm rounded-xl border-white/20">
            <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-blue-100 rounded-full">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="mb-2 font-semibold text-gray-800">Fast Loading</h3>
            <p className="text-sm text-gray-600">Quick access to all your educational resources</p>
          </div>

          <div className="p-6 text-center border bg-white/70 backdrop-blur-sm rounded-xl border-white/20">
            <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-purple-100 rounded-full">
              <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h3 className="mb-2 font-semibold text-gray-800">User Friendly</h3>
            <p className="text-sm text-gray-600">Intuitive interface designed for students</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LoginEmbed;